import { ref, computed } from 'vue';
import { getReviewSummary } from '../api/getReviewSummary';
import type { ReviewSummary } from '../model/types';

const summary = ref<ReviewSummary | null>(null);

export const fetchReviewSummary = async (hotelId: number): Promise<ReviewSummary | null> => {
  if (summary.value) return summary.value;

  try {
    summary.value = await getReviewSummary(hotelId);
  } catch {
    summary.value = null;
  }

  return summary.value;
};

export const useReviewSummary = () => ({
  hasSummary: computed(() => summary.value !== null),
  praised: computed(() => summary.value?.praised ?? []),
  caveats: computed(() => summary.value?.caveats ?? []),
  hotelSummary: computed(() => summary.value?.hotelSummary ?? ''),
  reviewsTotal: computed(() => summary.value?.reviewsTotal ?? 0),
  period: computed(() => summary.value?.period ?? { from: '', to: '' }),
});
